function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "call",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-48,-336)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8,0,0,1,11,1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55,350C55,349.448 54.44,349 53.75,349C52.986,349 52.014,349 51.25,349C50.56,349 50,349.448 50,350C50,351.537 50,354.463 50,356C50,356.552 50.56,357 51.25,357C52.014,357 52.986,357 53.75,357C54.44,357 55,356.552 55,356C55,354.463 55,351.537 55,350Z",
    style: {
      fill: "rgb(144,224,239)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8,0,0,1,33,1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55,350C55,349.448 54.44,349 53.75,349C52.986,349 52.014,349 51.25,349C50.56,349 50,349.448 50,350C50,351.537 50,354.463 50,356C50,356.552 50.56,357 51.25,357C52.014,357 52.986,357 53.75,357C54.44,357 55,356.552 55,356C55,354.463 55,351.537 55,350Z",
    style: {
      fill: "rgb(144,224,239)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2,0,0,1.2,-13.4,-70.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67,360.667C67,359.746 66.254,359 65.333,359L63.667,359C62.746,359 62,359.746 62,360.667L62,362.333C62,363.254 62.746,364 63.667,364L65.333,364C66.254,364 67,363.254 67,362.333L67,360.667Z",
    style: {
      fill: "rgb(144,224,239)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.041,349L52,349C50.895,349 50,349.895 50,351L50,357C50,358.105 50.895,359 52,359L54,359C55.105,359 56,358.105 56,357L56,351C56,349.912 55.131,349.027 54.049,349.001C54.551,343.95 58.818,340 64,340C69.182,340 73.449,343.95 73.951,349.001C72.869,349.027 72,349.912 72,351L72,357C72,358.093 72.876,358.981 73.965,359C73.937,359.195 73.893,359.385 73.834,359.568C73.382,360.978 72.059,362 70.5,362L68,362C68,360.343 66.657,359 65,359L63,359C61.343,359 60,360.343 60,362C60,362.329 60,362.671 60,363C60,364.657 61.343,366 63,366L65,366C66.311,366 67.426,365.159 67.834,363.986C67.888,363.995 67.943,364 68,364L70.5,364C72.95,364 75.028,362.394 75.738,360.179C75.859,359.802 75.941,359.407 75.977,359L76,359C77.105,359 78,358.105 78,357L78,351C78,349.895 77.105,349 76,349L75.959,349C75.455,342.895 70.371,338.08 64.155,338.001L64,338C57.713,338 52.55,342.845 52.041,349ZM66,362L66,363C66,363.552 65.552,364 65,364C65,364 63,364 63,364C62.448,364 62,363.552 62,363L62,362C62,361.448 62.448,361 63,361C63,361 65,361 65,361C65.552,361 66,361.448 66,362ZM54,351L52,351L52,357L54,357L54,351ZM76,351L74,351L74,357L76,357L76,351Z",
    style: {
      fill: "rgb(25,144,167)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.74c6b144d198fc50db64f797168013b5.svg";
export { ForwardRef as ReactComponent };